import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../../../../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalendarComponent } from './calendar.component';
import { CalendarStepOneComponent } from './components/calendar-step-one/calendar-step-one.component';
import { CalendarStepTwoComponent } from './components/calendar-step-two/calendar-step-two.component';
import { CalendarStepThreeComponent } from './components/calendar-step-three/calendar-step-three.component';
import { CalendarSlotComponent } from './components/calendar-slot/calendar-slot.component';
import { DpDatePickerModule } from 'ng2-date-picker';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { ScheduleRepeatFormComponent } from './components/calendar-slot/schedule-repeat-form/schedule-repeat-form.component';

const bookingRoutes: Routes = [
  { path: '', component: CalendarComponent },
  { path: 'edit/:id', component: CalendarComponent },
];

@NgModule({
  declarations: [
    CalendarComponent,
    CalendarStepOneComponent,
    CalendarStepTwoComponent,
    CalendarStepThreeComponent,
    CalendarSlotComponent,
    ScheduleRepeatFormComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(bookingRoutes),
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    DpDatePickerModule,
    MatIconModule,
    MatDatepickerModule,
    MatSelectModule,
    MatInputModule,
  ]
})
export class BookingModule { }
